import { createFileRoute } from "@tanstack/react-router";
import { AdultPage } from "../pages/AdultPage";

export const Route = createFileRoute("/adult")({
  component: AdultPage,
});
